<div class="wrap">
    <app-form-sign-in [action]="'user'"></app-form-sign-in>
    <div class="or">
        <div class="ligne"></div>
        <span>Ou</span>
    </div>
    <div class="sign_up_google" >
        <div class="img"><img src="assets/img/icone/google-brands.svg" alt="google"></div>
        <span>Connexion avec Google</span>
    </div>
    <div class="sign_up_facebook" >
        <div class="img"><img src="assets/img/icone/facebook-brands.svg" alt="facebook"></div>
        <span>Connexion avec Facebook</span>
    </div>
</div>
